import { render, staticRenderFns } from "./szSensors.vue?vue&type=template&id=fb510786&scoped=true"
import script from "./szSensors.vue?vue&type=script&lang=js"
export * from "./szSensors.vue?vue&type=script&lang=js"
import style0 from "./szSensors.vue?vue&type=style&index=0&id=fb510786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb510786",
  null
  
)

export default component.exports